// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1rKgh","noInteraction":"EventWrapper_noInteraction__1g8Aj"};